'use client';

import React, { useCallback, useEffect, useState } from 'react';
import { useRollbar } from '../../hooks';
import { getWalkerServiceCategoryGallery } from '../../hooks/api/getWalkerServiceCategoryGallery';
import { WalkerProfileProps } from '../../pages/walker-profile/[promoCode]';
import { WalkerServiceCategoryGallery } from '../../types/api';
import { WalkerProfileSchemas } from './components/PCGProfileSchemas';
import { PCGProfileContainer } from './PCGProfileContainer';
type Props = {
  data: WalkerProfileProps['value'];
  identifier: string;
  queryParams?: Record<string, string>;
};
export type ServicesGallery = Array<{
  items: WalkerServiceCategoryGallery['items'];
  serviceCategory: string;
}>;
export const WalkerProfileContext = ({
  data,
  identifier,
  queryParams
}: Props) => {
  const [servicesGallery, setServicesGallery] = useState<ServicesGallery>([]);
  const rollbar = useRollbar();
  const getServiceCategoryGallery = useCallback(async () => {
    let categoryGallery: WalkerServiceCategoryGallery[];
    const servicesOffered = data.servicesOffered?.items;
    if (!servicesOffered?.length) {
      return;
    }
    const categoryGalleryPromises = servicesOffered.map(category => getWalkerServiceCategoryGallery({
      identifier,
      category: category.serviceCategory
    }));
    try {
      categoryGallery = await Promise.all(categoryGalleryPromises);
      setServicesGallery(() => categoryGallery.map((gallery: WalkerServiceCategoryGallery, index) => ({
        serviceCategory: servicesOffered?.[index].serviceCategory,
        items: gallery.items
      })));
    } catch (error) {
      rollbar.error(JSON.stringify(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identifier]);
  useEffect(() => {
    getServiceCategoryGallery();
  }, [getServiceCategoryGallery]);
  return <>
      <PCGProfileContainer data={data} servicesGallery={servicesGallery} identifier={identifier} queryParams={queryParams} data-sentry-element="PCGProfileContainer" data-sentry-source-file="index.tsx" />
      <WalkerProfileSchemas profile={data.profile} location={data.location} data-sentry-element="WalkerProfileSchemas" data-sentry-source-file="index.tsx" />
    </>;
};